// CAUTION: Change the string values with care. Changing this value will likely need you to change a value in the respective integration console to
// pass the right integration id in the query param.
export enum Integration {
    ALARM_DOT_COM = "adc",
    ALEXA = "alexa",
    GOOGLE_ASSISTANT = "googlehome",
    SMART_THINGS = "smartthings",
    SMART_THINGS_SCHEMA = "smartthings_schema",
}

export enum IntegrationEnv {
    PROD = "prod",
    BETA = "beta",
    DEV = "dev",
}
